export default __webpack_public_path__ + "static/media/r2.d80cb7c4.jpg";